export default __webpack_public_path__ + "static/Calibre-RegularItalic-6153d566cd6b653cc2ecf8fff675b747.ttf";